.activity-modal-header {
    padding: 6px 16px 12px 16px;
    box-sizing: border-box;
    background-color: var(--skeleton-grey);
    border-bottom: 1px solid var(--off-white-dk);
}

.activity-modal-header-new {
    padding: 8px 16px;
}

.modal-header-title-editable {
    margin-left: -8px;
}

.activity-modal-sidebar {
    height: 100%;
    box-sizing: border-box;
    border-right: 1px solid var(--off-white-dk);
    min-width: 180px;
}

.close-button-container {
    position: absolute;
    top: -24px;
    right: -2px;
}

.activity-modal-header-title {
    text-align: left;
    padding: 0;
    padding-left: 8px;
    margin-left: -8px;
    padding-top: 5px;
    padding-bottom: 5px;
    border: 1px solid transparent;
    border-radius: 3px;
    height: 34px;
    width: 745px;
}

.activity-modal-header-title:hover {
    border-color: var(--off-white-dk);
}

.activity-modal-header-title-disabled:hover {
    border-color: transparent;
    cursor: default;
}
